import React from "react"
import { Box } from "@material-ui/core/"
const AnonymousLayout = ({ children, classes }) => {
  return (
    <Box component="div" className="hbku-pg-wrapper hbku-auth-wrapper">
      {children}
    </Box>
  )
}
export default AnonymousLayout
